import { apiSlice } from "../apiSlice";

const NOTES_URL = "/notes";

export const noteApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // All of the user's notes (dashboard groups these by algorithmSlug).
    getMyNotes: builder.query({
      query: () => ({
        url: NOTES_URL,
        method: "GET",
      }),
      providesTags: ["Notes"],
    }),

    // Notes for a single algorithm.
    getNotesBySlug: builder.query({
      query: (slug) => ({
        url: `${NOTES_URL}/${slug}`,
        method: "GET",
      }),
      providesTags: ["Notes"],
    }),

    createNote: builder.mutation({
      query: (data) => ({
        url: NOTES_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Notes"],
    }),

    updateNote: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${NOTES_URL}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Notes"],
    }),

    deleteNote: builder.mutation({
      query: (id) => ({
        url: `${NOTES_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Notes"],
    }),
  }),
});

export const {
  useGetMyNotesQuery,
  useGetNotesBySlugQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
} = noteApiSlice;
